export default __webpack_public_path__ + "static/media/awc-dropdown.96db5026.webp";